import { Languages } from "lucide-react";
import { DILLER, dil, dilAyarla } from "@/lib/dil";
import { cn } from "@/lib/cn";

/** Dil değişimi sayfayı yeniler; gerekçe lib/dil.ts başında. */
export function DilSecici({ className }: { className?: string }) {
  const aktif = dil();
  const sonraki = DILLER[(DILLER.findIndex((d) => d.kod === aktif) + 1) % DILLER.length]!;
  return (
    <button
      type="button"
      aria-label={`Switch to ${sonraki.ad}`}
      title={sonraki.ad}
      onClick={() => dilAyarla(sonraki.kod)}
      className={cn(
        "inline-flex h-9 items-center gap-1.5 rounded-md border border-line bg-surface px-2 text-ink-2 transition-colors hover:border-line-strong hover:text-ink",
        className,
      )}
    >
      <Languages size={16} />
      <span className="text-xs font-medium">{sonraki.kisa}</span>
    </button>
  );
}
